export { PremiumFaq as SearchableFaq } from "../conversion-sections"
export type { PremiumFaqProps as SearchableFaqProps } from "../conversion-sections"